import React from 'react'
import styles from "./SearchModal.module.scss"
import ADD_ICON from "../../assets/png/addstock.png"
import SearchBar from 'components/layouts/homelayout/SearchBar'
import { addStock, filtered } from 'redux/stockSlice'
import { useDispatch } from 'react-redux'

const SearchModal = (props) => {
    const dispatch = useDispatch()
    return (
        // <div className={styles.modal_container} onClick={() => {
        //     props?.setShow(false)
        //     props?.setTerm('')
        // }
        // }>
        //     <div className={styles.search} onClick={(e) => {
        //         e.stopPropagation()
        //     }}>
        //         <div style={{ display: "flex", gap: "245px", fontWeight: "900", borderBottom: "1px solid #EEE", padding: "9px 0px" }}><div>Symbol</div>
        //             <div>Name</div>   <div>Action</div></div>
        //         {props?.search?.length == 0 ?
        //             <div>No Results Found</div>
        //             :
        //             props?.search?.map((e) => {
        //                 return <div className={styles.modal_content}>
        //                     <div style={{ display: "flex", width: "100%" }}>
        //                         <div style={{ width: "13%", textAlign: "left", fontWeight: "800" }}>
        //                             {e?.symbol}
        //                         </div>
        //                         <div>
        //                             {e?.name}
        //                         </div>
        //                     </div>
        //                     <div>
        //                         <img src={ADD_ICON} className={styles.modal_add} onClick={() => {
        //                             dispatch(addStock(e)).then(() => {
        //                                 dispatch(filtered(null))
        //                             })
        //                             props?.setShow(false)
        //                             props?.setTerm("")
        //                         }} />
        //                     </div>
        //                 </div>
        //             })
        //         }
        //     </div>
        // </div >

        <div className={styles.search} onClick={(e) => {
            e.stopPropagation()
        }}>
            <div style={{ display: "flex", gap: "150px", fontWeight: "900", borderBottom: "1px solid #EEE", padding: "9px 0px" }}><div>Symbol</div>
                <div>Name</div>   <div>Action</div></div>
            {props?.search?.length == 0 ?
                <div>No Results Found</div>
                :
                props?.search?.map((e) => {
                    return <div className={styles.modal_content}>
                        <div style={{ display: "flex", width: "100%", gap: "10px" }}>
                            <div style={{ width: "13%", textAlign: "left", fontWeight: "800" }}>
                                {e?.symbol}
                            </div>
                            <div>
                                {e?.name}
                            </div>
                        </div>
                        <div>
                            <img src={ADD_ICON} className={styles.modal_add} onClick={() => {
                                dispatch(addStock(e)).then(() => {
                                    dispatch(filtered(null))
                                })
                                props?.setTerm("")
                            }} />
                        </div>
                    </div>
                })
            }
        </div>

    )
}

export default SearchModal